import { mapState, mapGetters } from 'vuex';

export const loggedIn = {
  ...mapGetters('auth', ['loggedIn']),
};

export const currentUser = {
  ...mapState('auth', ['currentUser']),
};

export const isLoginPath = (fullPath) => {
  const authenticate_routes = ['/login', '/login/teacher', '/login/cbs', '/tamaishiki_private'];

  return authenticate_routes.includes(fullPath);
};
